import CityPageTemplate from "../city-template/CityPageTemplate";
import { cincinnatiConfig } from "./data";

export default function CincinnatiPage() {
  return <CityPageTemplate config={cincinnatiConfig} />;
}